module.exports = __webpack_public_path__ + "media/components/src/assets/images/logo_sample-b9ef8eb2a6942f7559142c3a5254d9b0.png";